import PropTypes from 'prop-types';
import React from 'react';
import VisualizationPlaceholder from './VisualizationPlaceholder';
import {connect} from 'react-redux';
import {
  selectCardById,
  selectIsCardAccessDenied,
} from 'state/card/cardSelectors';
import {loadById} from 'state/card/cardActions';
import {selectIsDavinci} from 'state/environment/environmentSelectors';

// Strategies
import * as ChartStrategy from './VisualizationStrategies/Chart/ChartStrategy';
import * as DomoAppStrategy from './VisualizationStrategies/DomoApp/DomoAppStrategy';
import * as MasonStrategy from './VisualizationStrategies/Mason/MasonStrategy';
import * as TextStrategy from './VisualizationStrategies/Text/TextStrategy';
import * as TableStrategy from './VisualizationStrategies/Table/TableStrategy';
import * as SuperTableStrategy from './VisualizationStrategies/SuperTable/SuperTableStrategy';
import * as RoosterStrategy from './VisualizationStrategies/Rooster/RoosterStrategy';
import * as DocumentStrategy from './VisualizationStrategies/Document/DocumentStrategy';
import * as PollStrategy from './VisualizationStrategies/Poll/PollStrategy';
import * as ErrorStrategy from './VisualizationStrategies/Error/ErrorStrategy';

const renderStrategy = (card) => {
  switch (card.type) {
    case 'kpi':
    case 'drill_view':
      switch (card.metadata.chartType) {
        case 'badge_table':
        case 'badge_heatmap_table':
          return TableStrategy;
        default:
          return ChartStrategy;
      }
    case 'text':
    case 'Text':
      return TextStrategy;
    case 'domoapp':
      return DomoAppStrategy;
    case 'mason':
      return MasonStrategy;
    case 'image':
    case 'document':
      return DocumentStrategy;
    case 'poll':
      return PollStrategy;
    case 'supertable':
      return SuperTableStrategy;
    case 'rooster':
      return RoosterStrategy;
    default:
      return ErrorStrategy;
  }
};

export const SIZES = {
  CARD: 'card',
  DETAILS: 'details',
  MICRO: 'micro',
  HORIZONTAL: 'horizontal',
  TABLE: 'table',
  ICON: 'icon',
  PREVIEW: 'preview',
};

class Visualization extends React.Component {
  componentDidMount() {
    this.props.loadById(this.props.cardId);
  }

  render() {
    const {size, card, isAccessDenied, isDavinci} = this.props;

    if (isAccessDenied) {
      const ErrorComponent = ErrorStrategy[size];
      return <ErrorComponent {...this.props} />;
    }

    if (!card && size === SIZES.CARD) return <VisualizationPlaceholder />;
    if (!card) return null;

    const strategy = renderStrategy(card);

    if (strategy === ErrorStrategy && isDavinci)
      console.error('Error insufficient model: ' + card); //to be picked up by puppeteer and fail image

    const Component = strategy[size];

    if (!Component) return null;

    return <Component {...this.props} />;
  }
}

Visualization.propTypes = {
  pageId: PropTypes.string,
  cardId: PropTypes.node.isRequired,
  viewId: PropTypes.string,
  size: PropTypes.oneOf(Object.values(SIZES)).isRequired,
  filters: PropTypes.array,
  grain: PropTypes.string,
  range: PropTypes.number,
  dataControlFilters: PropTypes.array,
};

export default connect(
  (state, {cardId}) => ({
    card: selectCardById(state, cardId),
    isAccessDenied: selectIsCardAccessDenied(state, cardId),
    isDavinci: selectIsDavinci(state),
  }),
  {
    loadById,
  }
)(Visualization);
